import Parseable from '@/models/Parseable';
import Customer from '@/models/Customer';
import Actuator from '@/models/Actuator';
import Revision from '@/models/Revision';

export default class Project extends Parseable {

    public id!: string;
    public createdAt!: string;
    public name!: string;
    public anfrageNr!: string;
    public angebotsNr!: string;
    public actuators: Actuator[] = [];
    public revisions: Revision[] = [];
    public customer!: Customer;

    /**
     * Turns a plain object to a class object
     * @param object
     */
    public static parseFromObject(object: Partial<Project>): Project {
        const project = new Project();
        Object.assign(project, object);

        if (typeof object.customer === 'object' && object.customer !== null) {
            project.customer = Customer.parseFromObject(object.customer);
        }

        project.actuators = Array.isArray(object.actuators)
            ? Actuator.parseFromArray(object.actuators)
            : [];

        project.revisions = Array.isArray(object.revisions)
            ? Revision.parseFromArray(object.revisions)
            : [];

        return project;
    }

    public static parseFromArray(array: Partial<Project>[]): Project[] {
        if (!Array.isArray(array)) {
            return [];
        }

        return array.map((obj) => Project.parseFromObject(obj));
    }

    parseToObject(): any {
        return { ...this };
    }
}
